import { useTranslation } from 'react-i18next'
import { Col, Form, InputNumber, Row, Space } from '@vivaldis/antd-ui'
import {
  MEAL_VOUCHERS_CONTRIBUTION_VALUE_MAX,
  MEAL_VOUCHERS_CONTRIBUTION_VALUE_MIN,
  MEAL_VOUCHERS_TOTAL_VALUE_MAX,
  MEAL_VOUCHERS_TOTAL_VALUE_MIN
} from '../../../../../../../../Premiums'

interface Props {
  index: number
}

export const MealVouchers = ({ index }: Props) => {
  const { t } = useTranslation('web_ui')

  const valueFieldName = `premiumValuesInput[${index}].value`
  const contributionValueFieldName = `premiumValuesInput[${index}].contributionValue`

  return (
    <Row gutter={16}>
      <Col span={12}>
        <Form.Item
          name={valueFieldName}
          required
          label={t('position_form.step3.meal_vouchers.value.label')}
          tooltip={t('position_form.step3.meal_vouchers.value.tooltip')}
        >
          <Space.Compact block>
            <Space.Addon>
              {t('position_form.step3.meal_vouchers.value.addon_before')}
            </Space.Addon>
            <InputNumber
              name={valueFieldName}
              autoComplete="off"
              min={MEAL_VOUCHERS_TOTAL_VALUE_MIN}
              max={MEAL_VOUCHERS_TOTAL_VALUE_MAX}
              placeholder={t(
                'position_form.step3.meal_vouchers.value.placeholder'
              )}
              style={{ flexGrow: 1 }}
            />
            <Space.Addon>
              {t('position_form.step3.meal_vouchers.value.addon_after')}
            </Space.Addon>
          </Space.Compact>
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          name={contributionValueFieldName}
          required
          label={t(
            'position_form.step3.meal_vouchers.contribution_value.label'
          )}
          tooltip={t(
            'position_form.step3.meal_vouchers.contribution_value.tooltip'
          )}
        >
          <Space.Compact block>
            <Space.Addon>
              {t(
                'position_form.step3.meal_vouchers.contribution_value.addon_before'
              )}
            </Space.Addon>
            <InputNumber
              name={contributionValueFieldName}
              min={MEAL_VOUCHERS_CONTRIBUTION_VALUE_MIN}
              max={MEAL_VOUCHERS_CONTRIBUTION_VALUE_MAX}
              placeholder={t(
                'position_form.step3.meal_vouchers.contribution_value.placeholder'
              )}
              style={{ flexGrow: 1 }}
            />
            <Space.Addon>
              {t(
                'position_form.step3.meal_vouchers.contribution_value.addon_after'
              )}
            </Space.Addon>
          </Space.Compact>
        </Form.Item>
      </Col>
    </Row>
  )
}
